import {
  EmptyState,
  LoadingButton,
} from '@airship-platform/jam-web/components';
import { Link, useNavigate } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import { SectionWrapper } from '../../../patterns';
import OutageExperienceSection, {
  OutageExperienceInputs,
} from './sections/OutageExperienceSection';

const FORM_ID = 'proposalOutageExperienceForm';

const OutageExperiencePage: React.FC = () => {
  const navigate = useNavigate();
  const { currentProposal, isLoading, updateAppointmentProposal } =
    useAppointmentProposals();

  if (!currentProposal) {
    return (
      <EmptyState
        title="Appointment not found"
        subtitle="Oops! The requested appointment was not found."
      />
    );
  }

  const onSubmit = (outageExperience: OutageExperienceInputs) =>
    updateAppointmentProposal(
      currentProposal.appointmentId,
      currentProposal.appointmentProposalId,
      { outageExperience }
    ).then(() => navigate(-1));

  return (
    <SectionWrapper
      maxWidth={'42rem'}
      width={'100%'}
      header="What matters most during an outage?"
      subheader="Select the items that are most important to the homeowner during a power outage."
      actionsButtons={{
        left: {
          color: 'softGold',
          component: Link,
          to: '../service-menu',
          label: 'Cancel',
        },
        right: {
          type: 'submit',
          component: LoadingButton,
          form: FORM_ID,
          label: 'Save',
          loading: isLoading,
          disabled: isLoading,
        },
      }}
    >
      <OutageExperienceSection
        formId={FORM_ID}
        defaultValues={currentProposal.outageExperience}
        onSubmit={onSubmit}
      />
    </SectionWrapper>
  );
};

export default OutageExperiencePage;
